module.exports = __webpack_public_path__ + "static/76be3cbf7ac1901a398bdb2212c56e5fecc01931132211152921d17928d7e51c-cd10cfe75faa60e1b32e524e457f737b.png";